import { withStyles } from '@material-ui/core/styles';
import styles from './AssociatePinsSelectors.styles';
import AssociatePinsSelectors from './AssociatePinsSelectors';

export default withStyles(styles)(AssociatePinsSelectors);
